import { z } from 'zod';

import { AI_MODEL_CHOICE_OPTIONS, AI_MODEL_TYPE_OPTIONS } from '~/data/company';

const zodAiModelEntrySchema = z.object({
  modelId: z.string().trim().min(1),
  modelType: z.enum(AI_MODEL_TYPE_OPTIONS).prefault('di'),
});

export const zodEvaluateOcrModelPerformanceSchema = z
  .object({
    count: z.int().min(1).max(50).prefault(5),
    includeDocuments: z.boolean().prefault(true),
    includeOcrOutput: z.boolean().prefault(true),
    lvlmPerformance: z.enum(['high', 'medium']).prefault('high'),
    ocrConfig: z.object({
      diPlusAiFoundryFieldsToReplace: z
        .preprocess((value) => {
          const v = value ?? [];
          if (typeof v === 'string') {
            return v.trim() === '' ? null : v.trim();
          }

          if (Array.isArray(v)) {
            const joined = v.filter(Boolean).join(',');
            return joined === '' ? null : joined;
          }

          return null;
        }, z.string().nullable())
        .prefault([]),
      languageEncoding: z.string().nullable().prefault('DE'),
      model: z.array(zodAiModelEntrySchema).min(1),
      modelChoice: z
        .union([z.enum(AI_MODEL_CHOICE_OPTIONS), z.literal('')])
        .prefault('di')
        .nullable(),
      processBulk: z.enum(['true', 'false']).nullable().prefault('false'),
    }),
    outputMappingType: z.enum(['delivery', 'invoice']).optional(),
    setup: z.enum(['detailed', 'summary', 'natural']).prefault('detailed'),
    useLvlm: z.enum(['true', 'false', 'auto', 'shadowing']).prefault('false'),
  })
  .transform((data) => {
    if (data?.includeOcrOutput && !data?.outputMappingType) {
      // Set the output mapping type based on the model id as fallback
      return {
        ...data,
        outputMappingType: data.modelId?.startsWith('inv_')
          ? 'invoice'
          : 'delivery',
      };
    }

    return data;
  });
